"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConditionEditor = exports.conditionEditorPropTypes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconClose = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconClose"));

var _colors = require("@cimpress/react-components/lib/colors");

var _Select = _interopRequireDefault(require("@cimpress/react-components/lib/Select"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _OperatorSelector = require("../components/OperatorSelector");

var _ValuesEditor = _interopRequireDefault(require("../components/ValuesEditor"));

var _propTypes2 = require("./propTypes");

var _messages = _interopRequireDefault(require("./messages"));

var _styledComponents = require("./styledComponents");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var optionType = _propTypes["default"].shape(_propTypes2.optionShape);

var propertyType = _propTypes["default"].shape(_propTypes2.propertyConditionAttributeShape);

var conditionEditorPropTypes = {
  condition: _propTypes["default"].shape(_propTypes2.constraintConditionShape).isRequired,
  conditions: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintConditionShape)),
  results: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintConditionShape)),
  attributes: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([optionType, propertyType])).isRequired,
  updateCondition: _propTypes["default"].func.isRequired,
  removeCondition: _propTypes["default"].func,
  allowFormulas: _propTypes["default"].bool,
  style: _propTypes["default"].string
};
exports.conditionEditorPropTypes = conditionEditorPropTypes;

var ConditionEditorInternal =
/*#__PURE__*/
function (_Component) {
  _inherits(ConditionEditorInternal, _Component);

  var _super = _createSuper(ConditionEditorInternal);

  function ConditionEditorInternal(props) {
    var _this;

    _classCallCheck(this, ConditionEditorInternal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "removeCondition", function () {
      return _this.props.removeCondition(_this.props.condition);
    });

    _defineProperty(_assertThisInitialized(_this), "updateConditionOption", function (selectedOption) {
      var newCondition = _objectSpread(_objectSpread({}, _this.props.condition), {}, {
        attribute: selectedOption ? selectedOption.value : null,
        values: []
      });

      _this.props.updateCondition(_this.props.condition, newCondition);

      _this.setState({
        selectedOption: selectedOption
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateConditionOperator", function (selectedOperator) {
      var newCondition = _objectSpread(_objectSpread({}, _this.props.condition), {}, {
        operator: selectedOperator
      });

      _this.props.updateCondition(_this.props.condition, newCondition);
    });

    _defineProperty(_assertThisInitialized(_this), "updateConditionValues", function (values) {
      var updatedCondition = (0, _cloneDeep["default"])(_this.props.condition);
      updatedCondition.values = values;

      _this.props.updateCondition(_this.props.condition, updatedCondition);
    });

    var condition = props.condition;
    _this.state = {
      selectedOption: {
        value: condition.attribute,
        label: condition.attribute
      }
    };
    return _this;
  }

  _createClass(ConditionEditorInternal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          condition = _this$props.condition,
          conditions = _this$props.conditions,
          results = _this$props.results,
          attributes = _this$props.attributes,
          removeCondition = _this$props.removeCondition,
          allowFormulas = _this$props.allowFormulas,
          formatMessage = _this$props.intl.formatMessage;
      var selectedOption = this.state.selectedOption;
      var usedAttributes = [].concat(_toConsumableArray(conditions), _toConsumableArray(results)).reduce(function (accumulator, existingCondition) {
        return existingCondition.attribute ? _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, existingCondition.attribute, 1)) : accumulator;
      }, {}); // allow the user to make changes to the current selected attribute

      delete usedAttributes[condition.attribute];
      var selectableAttributes = Object.values(attributes).filter(function (attribute) {
        return !usedAttributes[attribute.name];
      });
      var optionNames = selectableAttributes.map(function (attribute) {
        return {
          value: attribute.name,
          label: attribute.name
        };
      });
      var selectedAttribute = attributes[condition.attribute];
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "row"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "col-sm-3"
        },
        /*#__PURE__*/
        _react["default"].createElement(_Select["default"], {
          clearable: false,
          label: formatMessage(_messages["default"].optionLabel),
          value: selectedOption,
          options: optionNames,
          onChange: this.updateConditionOption // If we have already added values, the selected attribute needs to be disabled
          ,
          disabled: condition.values && condition.values.length > 0
        })),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "col-sm-2"
        },
        /*#__PURE__*/
        _react["default"].createElement(_OperatorSelector.OperatorSelector, {
          attributeType: selectedAttribute ? selectedAttribute.type : null,
          selectedOperator: condition.operator,
          onSelectionChanged: this.updateConditionOperator
        })),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "col-sm-6"
        },
        /*#__PURE__*/
        _react["default"].createElement(_ValuesEditor["default"], {
          condition: condition,
          attributes: attributes,
          allowFormulas: allowFormulas,
          updateConditionValues: this.updateConditionValues
        })),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "col-sm-1"
        }, removeCondition ?
        /*#__PURE__*/
        _react["default"].createElement(_styledComponents.RoundButton, {
          type: "link",
          onClick: this.removeCondition
        },
        /*#__PURE__*/
        _react["default"].createElement(_IconClose["default"], {
          size: "lg",
          color: _colors.teal.base
        })) : null))
      );
    }
  }]);

  return ConditionEditorInternal;
}(_react.Component);

_defineProperty(ConditionEditorInternal, "propTypes", _objectSpread(_objectSpread({}, conditionEditorPropTypes), {}, {
  intl: _propTypes["default"].shape(_propTypes2.intlShape).isRequired
}));

_defineProperty(ConditionEditorInternal, "defaultProps", {
  conditions: [],
  results: [],
  style: '',
  allowFormulas: true
});

var ConditionEditor = (0, _reactIntl.injectIntl)(ConditionEditorInternal);
exports.ConditionEditor = ConditionEditor;
var _default = ConditionEditor;
exports["default"] = _default;